import { notify } from '@Support/notify';

export const defaultWishlistConfig = {
    key: 'wishlist',
    activeClass: 'is-active',
    stats: { send: true },
    onAdd: function($self) {
        notify({
            type: 'storageItem',
            content: __('add_to_wishlist_msg'),
            $target: $self.get(0)
        });
        notify({
            type: 'header',
            content: __('add_to_wishlist_msg')
        });
    }
}